import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
export default {
  name: "EditStyle",
  props: {
    haveBackground: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: "center"
    },
    classRef: {
      type: String,
      default: ""
    },
    elementType: {
      type: String,
      required: true
    },
    isPrioritary: {
      type: Boolean,
      default: false
    },
    configStylePainel: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      showBtnEdit: true,
      showDialogEdit: false,
      showSizes: false,
      showFontStyle: false,
      requestService: new RequestService(),
      formToolEdit: {
        textColor: "",
        backgroundColor: "",
        fontSize: "",
        weightFont: ""
      },
      fontSizes: Array.from({
        length: 100
      }, function (_, i) {
        return i + 1 + "px";
      }),
      fontWeight: ["Normal", "Bold", "Bolder", "Lighter", "100", "200", "300", "400", "500", "600", "700", "800", "900"]
    };
  },
  methods: {
    closeForm: function closeForm() {
      this.showBtnEdit = true;
      this.showDialogEdit = false;
    },
    toggleEdit: function toggleEdit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _element2, _element3;
        var element, _element;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setPosition();
              _context.next = 3;
              return _this.emitEventHide();
            case 3:
              if (!(_this.$props.elementType === undefined)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.t0 = _this.$props.elementType;
              _context.next = _context.t0 === "containerPainelNameHeader" ? 8 : _context.t0 === "fullDateHeader" ? 11 : _context.t0 === "hourHeader" ? 14 : _context.t0 === "patientAndLocalLabelMain" ? 17 : _context.t0 === "containerPatientAndLocalCall" ? 19 : _context.t0 === "hourHistory" ? 22 : _context.t0 === "containerLastCallHistory" ? 25 : _context.t0 === "containerPatientAndCodeCallHistory" ? 28 : _context.t0 === "containerPatientAndLocalCallPrioritary" ? 31 : _context.t0 === "footer" ? 33 : 36;
              break;
            case 8:
              element = _this.configStylePainel.containerPainelNameHeader;
              _this.formToolEdit.backgroundColor = _this.configStylePainel.primaryColor.color;
              return _context.abrupt("break", 37);
            case 11:
              element = _this.configStylePainel.fullDateHeader;
              _this.formToolEdit.backgroundColor = _this.configStylePainel.secondaryColor.color;
              return _context.abrupt("break", 37);
            case 14:
              element = _this.configStylePainel.hourHeader;
              _this.formToolEdit.backgroundColor = _this.configStylePainel.secondaryColor.color;
              return _context.abrupt("break", 37);
            case 17:
              element = _this.configStylePainel.patientAndLocalLabelMain;
              return _context.abrupt("break", 37);
            case 19:
              element = _this.configStylePainel.containerPatientAndLocalCall;
              _this.formToolEdit.backgroundColor = _this.isPrioritary ? _this.configStylePainel.prioritaryColor.color : _this.configStylePainel.primaryColor.color;
              return _context.abrupt("break", 37);
            case 22:
              element = _this.configStylePainel.hourHistory;
              _this.formToolEdit.textColor = element.primaryColor;
              return _context.abrupt("break", 37);
            case 25:
              element = _this.configStylePainel.containerLastCallHistory;
              _this.formToolEdit.backgroundColor = _this.configStylePainel.primaryColor.color;
              return _context.abrupt("break", 37);
            case 28:
              element = _this.configStylePainel.containerPatientAndCodeCallHistory;
              _this.formToolEdit.backgroundColor = _this.isPrioritary ? _this.configStylePainel.prioritaryColor.color : _this.configStylePainel.primaryColor.color;
              return _context.abrupt("break", 37);
            case 31:
              element = _this.configStylePainel.containerPatientAndLocalCallPrioritary;
              return _context.abrupt("break", 37);
            case 33:
              element = _this.configStylePainel.footer;
              _this.formToolEdit.backgroundColor = _this.configStylePainel.secondaryColor.color;
              return _context.abrupt("break", 37);
            case 36:
              return _context.abrupt("break", 37);
            case 37:
              if (_this.$props.elementType !== "hourHistory") {
                _this.formToolEdit.textColor = (_element = element) === null || _element === void 0 ? void 0 : _element.color;
              }
              _this.formToolEdit.fontSize = (_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.fontSize;
              _this.formToolEdit.weightFont = (_element3 = element) === null || _element3 === void 0 ? void 0 : _element3.styleFont;
              _this.showBtnEdit = !_this.showBtnEdit;
              _this.showDialogEdit = !_this.showDialogEdit;
            case 42:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    emitEventHide: function emitEventHide() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$root.$emit("hideComponent");
              return _context2.abrupt("return", new Promise(function (res) {
                setTimeout(function () {
                  res(true);
                }, 100);
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setPosition: function setPosition() {
      var toolDiv = document.querySelectorAll(".main-popup");
      switch (this.$props.position) {
        case "center":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-center");
          });
          break;
        case "top":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-top");
          });
          break;
        case "top-left":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-top-left");
          });
          break;
        case "top-right":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-top-right");
          });
          break;
        case "top-center":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-top-center");
          });
          break;
        case "bottom":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-bottom");
          });
          break;
        case "bottom-left":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-bottom-left");
          });
          break;
        case "bottom-right":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-bottom-right");
          });
          break;
        case "bottom-center":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-bottom-center");
          });
          break;
        case "left":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-left");
          });
          break;
        case "right":
          toolDiv.forEach(function (e) {
            return e.classList.add("s-right");
          });
          break;
        default:
          break;
      }
    },
    toggleMenu: function toggleMenu(menu) {
      if (menu === "size") {
        this.showSizes = !this.showSizes;
      } else if (menu === "weight") {
        this.showFontStyle = !this.showFontStyle;
      }
    },
    selectOption: function selectOption(type, option) {
      if (type === "fontSize") {
        this.formToolEdit.fontSize = option;
      } else if (type === "fontStyle") {
        this.formToolEdit.weightFont = option;
      }
      this.showSizes = false;
      this.showFontStyle = false;
    },
    save: function save() {
      var _this3 = this;
      var menuEdited = this.$props.elementType;
      this.configStylePainel[menuEdited].color = this.formToolEdit.textColor;
      this.configStylePainel[menuEdited].fontSize = this.formToolEdit.fontSize;
      this.configStylePainel[menuEdited].styleFont = this.formToolEdit.weightFont;
      if (this.formToolEdit.backgroundColor !== "") {
        if (this.elementType === "footer" || this.elementType === "footer" || this.elementType === "fullDateHeader" || this.elementType === "hourHeader") {
          this.configStylePainel.secondaryColor.color = this.formToolEdit.backgroundColor;
        } else {
          if (this.isPrioritary) {
            this.configStylePainel.prioritaryColor.color = this.formToolEdit.backgroundColor;
          } else {
            this.configStylePainel.primaryColor.color = this.formToolEdit.backgroundColor;
          }
        }
      }
      var bodyRequest = _objectSpread({}, this.configStylePainel);
      for (var _i = 0, _Object$keys = Object.keys(bodyRequest); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (key !== "id" && key !== "clienteId") {
          bodyRequest[key] = JSON.stringify(bodyRequest[key]);
        }
      }
      if (this.configStylePainel.id == "config-style") {
        this.closeForm();
        return;
      }
      this.requestService.saveConfigStyle(bodyRequest, this.$route.params.cliente).then(function (e) {
        _this3.$root.$emit("updatePainelStyle");
      }).catch(function (err) {
        alert("Erro ao salvar");
        console.info(err);
      });
      this.closeForm();
    }
  },
  updated: function updated() {
    this.setPosition();
  },
  mounted: function mounted() {
    var _this4 = this;
    this.$root.$on("hideComponent", function () {
      _this4.showBtnEdit = true;
      _this4.showDialogEdit = false;
    });
    this.$root.$emit("updatePainelStyleMainLayout");
  }
};